export default __webpack_public_path__ + "static/media/background.50444685.jpg";